import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ activePage }) => {
    return (
        <header>
            <Link to="/" className="logo">
                <img src="/image.png" alt="Logo" />
                Fitness <span>Fever</span>
            </Link>

            <nav className="navbar">
                <Link to="/" className={activePage === 'home' ? 'active' : ''}>Home</Link>
                <Link to="/about" className={activePage === 'about' ? 'active' : ''}>About Us</Link>
                <Link to="/services" className={activePage === 'services' ? 'active' : ''}>Services</Link>
                <Link to="/plans" className={activePage === 'plans' ? 'active' : ''}>Plans</Link>
                <Link to="/contact" className={activePage === 'contact' ? 'active' : ''}>Contact</Link>
            </nav>

            <a href="https://wa.me/919833143308?text=Hello%20I%20am%20interested" className="btn nav-btn">GET STARTED</a>
            <div className="menu-toggle" id="menuToggle">
                <i className="fa-solid fa-bars"></i>
            </div>
        </header>
    );
};

export default Header;
